import { Component, Input, OnInit } from '@angular/core';
import { ShowRoomService } from 'src/app/services/showroom/showroom.service';

@Component({
  selector: 'app-chart-digital-number',
  templateUrl: './chart-digital-number.component.html',
  styleUrls: ['./chart-digital-number.component.css']
})
export class ChartDigitalNumberComponent implements OnInit {
  @Input('id') id : any;
  @Input('idCanvas') idCanvas : any;
  @Input('color') color : any;
  @Input('typeChart') typeChart : any;
  counter = 0;

  constructor(public showroomService: ShowRoomService) {}

  ngOnInit(): void {}
   
  ngAfterViewInit(): void {
    if(!this.showroomService.getPause()){
      var _this = this;
      setInterval(function(){
        _this.loadData(_this.id,_this.typeChart)
      },2000);
    }
  }

  loadData(id: any,typeChart:any): void{
    if(typeChart == 2){ // numeric
      this.showroomService.getSensorValue(id).subscribe(_ =>{
        this.counter = _.data.y
      });
    }else if(this.typeChart == 3){ // camera counting
      this.showroomService.getSensorCameraCounting().subscribe(_ =>{
        this.counter = _.data.y
      });
    }
  }

}
